import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UnifiedBankAccount } from '../../../../../models/entities/unified-bank-account';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { GrowlerService } from '../../../../../services/growler.service';
import { GenericDialogResult } from '../../generic-mat-dialog/generic-dialog-result';
import { PlaidService } from '../../../../../services/plaid.service';

export interface ToggleTransactionsDialogInput
{
    account: UnifiedBankAccount;
}

@Component({
    selector: 'app-toggle-transactions-dialog',
    templateUrl: './toggle-transactions-dialog.component.html',
})
export class ToggleTransactionsDialogComponent implements OnInit
{
    public isToggleInFlight: boolean = false;

    constructor(
            private _dialogRef: MatDialogRef<ToggleTransactionsDialogComponent>,
            private _bankAccountsService: BankAccountsService,
            private _growlerService: GrowlerService,
            private _plaidService: PlaidService,
            @Inject(MAT_DIALOG_DATA) public data: ToggleTransactionsDialogInput,
    ) {
    }

    ngOnInit() {
    }

    closeDialog() {
        this._dialogRef.close(<GenericDialogResult>{success: false});
    }

    toggleTransactions() {
        this.isToggleInFlight = true;
        const hasTransactionsToggled = !this.data.account.linkedBankAccount.pullsTransactions;

        this._plaidService.toggleTransactions(this.data.account.linkedBankAccount.id, hasTransactionsToggled).subscribe(
                () => {
                    if (hasTransactionsToggled) {
                        this._growlerService.success(
                                'Success',
                                'Transaction synchronization has been enabled for this account.',
                        );
                    } else {
                        this._growlerService.success(
                                'Success',
                                'Transaction synchronization has been disabled for this account.',
                        );
                    }
                    this.isToggleInFlight = true;
                    this._dialogRef.close(<GenericDialogResult>{
                        success: true,
                    });
                },
                () => {
                    this.isToggleInFlight = true;
                    if (hasTransactionsToggled) {
                        this._growlerService.error(
                                'Oops...',
                                'Transaction synchronization could not be enabled for this account. Please try again.',
                        );
                    } else {
                        this._growlerService.error(
                                'Oops...',
                                'Transaction synchronization could not be disabled for this account. Please try again.',
                        );
                    }
                },
        );
    }
}
